module.exports = __webpack_public_path__ + "web/img/verify1.69e2a12e.jpg";